/**
 * Script pour aligner le prix et "Taxes incluses" sur la même ligne
 * Classes ciblées : 
 * - Prix : .product-price--original
 * - Taxes : .product-price--tax
 * - Conteneur mobile : .product-price--root
 * - Wrapper : .product-price--wrapper
 */

(function() {
  'use strict';
  
  let alignmentApplied = false;
  
  function alignPriceAndTax() {
    // Détecter si on est sur mobile ou desktop
    const isMobile = window.innerWidth <= 767 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // PRIORITÉ 1 : Vérifier d'abord le conteneur root (mobile principalement, mais peut exister sur desktop)
    const rootContainer = document.querySelector('.product-price--root');
    
    if (rootContainer) {
      const priceElement = rootContainer.querySelector('.product-price--original');
      const taxElement = rootContainer.querySelector('.product-price--tax');
      
      if (priceElement && taxElement) {
        // Appliquer flexbox sur le conteneur root avec !important
        rootContainer.style.setProperty('display', 'flex', 'important');
        rootContainer.style.setProperty('align-items', 'baseline', 'important');
        rootContainer.style.setProperty('gap', '0.5rem', 'important');
        rootContainer.style.setProperty('flex-wrap', 'nowrap', 'important');
        
        // Si le prix est dans un wrapper, s'assurer que le wrapper est aussi inline
        const priceWrapper = priceElement.closest('.product-price--wrapper');
        if (priceWrapper) {
          priceWrapper.style.setProperty('display', 'inline-block', 'important');
          priceWrapper.style.setProperty('margin', '0', 'important');
          priceWrapper.style.setProperty('padding', '0', 'important');
        }
        
        // S'assurer que les éléments enfants sont bien alignés
        priceElement.style.setProperty('display', 'inline-block', 'important');
        taxElement.style.setProperty('display', 'inline-block', 'important');
        taxElement.style.setProperty('margin-left', '0', 'important');
        taxElement.style.setProperty('margin-top', '0', 'important');
        taxElement.style.setProperty('margin-bottom', '0', 'important');
        taxElement.style.setProperty('vertical-align', 'baseline', 'important');
        
        alignmentApplied = true;
        return;
      }
    }
    
    // PRIORITÉ 2 : Cas desktop - trouver les éléments directement (sans root container)
    const priceElement = document.querySelector('.product-price--original');
    const taxElement = document.querySelector('.product-price--tax');
    
    if (!priceElement || !taxElement) {
      return; // Les éléments n'existent pas encore
    }
    
    // Vérifier si les éléments sont dans un root container (au cas où)
    const priceRoot = priceElement.closest('.product-price--root');
    const taxRoot = taxElement.closest('.product-price--root');
    
    if (priceRoot && taxRoot && priceRoot === taxRoot) {
      // Les deux sont dans le même root, utiliser la logique root
      priceRoot.style.setProperty('display', 'flex', 'important');
      priceRoot.style.setProperty('align-items', 'baseline', 'important');
      priceRoot.style.setProperty('gap', '0.5rem', 'important');
      priceRoot.style.setProperty('flex-wrap', 'nowrap', 'important');
      
      const priceWrapper = priceElement.closest('.product-price--wrapper');
      if (priceWrapper) {
        priceWrapper.style.setProperty('display', 'inline-block', 'important');
        priceWrapper.style.setProperty('margin', '0', 'important');
      }
      
      alignmentApplied = true;
      return;
    }
    
    // Cas 1 : Les éléments sont frères directs (l'un après l'autre)
    if (priceElement.nextElementSibling === taxElement || 
        taxElement.previousElementSibling === priceElement) {
      // Mettre les deux en inline-block
      priceElement.style.setProperty('display', 'inline-block', 'important');
      taxElement.style.setProperty('display', 'inline-block', 'important');
      taxElement.style.setProperty('margin-left', '0.5rem', 'important');
      taxElement.style.setProperty('margin-top', '0', 'important');
      taxElement.style.setProperty('margin-bottom', '0', 'important');
      taxElement.style.setProperty('vertical-align', 'baseline', 'important');
      alignmentApplied = true;
      return;
    }
    
    // Cas 2 : Trouver le parent commun
    let priceParent = priceElement.parentElement;
    let commonParent = null;
    
    // Remonter jusqu'au parent commun qui contient les deux
    while (priceParent && priceParent !== document.body) {
      if (priceParent.contains(taxElement)) {
        commonParent = priceParent;
        break;
      }
      priceParent = priceParent.parentElement;
    }
    
    if (commonParent) {
      // Le parent commun contient les deux - utiliser flexbox
      commonParent.style.setProperty('display', 'flex', 'important');
      commonParent.style.setProperty('align-items', 'baseline', 'important');
      commonParent.style.setProperty('gap', '0.5rem', 'important');
      commonParent.style.setProperty('flex-wrap', 'nowrap', 'important');
      alignmentApplied = true;
      return;
    }
    
    // Cas 3 : Les éléments sont dans des conteneurs séparés
    // Mettre les taxes en inline-block et les positionner
    taxElement.style.setProperty('display', 'inline-block', 'important');
    taxElement.style.setProperty('margin-left', '0.5rem', 'important');
    taxElement.style.setProperty('margin-top', '0', 'important');
    taxElement.style.setProperty('margin-bottom', '0', 'important');
    taxElement.style.setProperty('vertical-align', 'baseline', 'important');
    
    // Si les deux ont le même parent, essayer de les regrouper
    if (priceElement.parentElement === taxElement.parentElement) {
      const parent = priceElement.parentElement;
      parent.style.setProperty('display', 'flex', 'important');
      parent.style.setProperty('align-items', 'baseline', 'important');
      parent.style.setProperty('gap', '0.5rem', 'important');
      parent.style.setProperty('flex-wrap', 'nowrap', 'important');
      alignmentApplied = true;
    }
  }
  
  // Fonction pour exécuter l'alignement avec plusieurs tentatives
  function executeAlignment() {
    // Réinitialiser le flag pour forcer la réapplication
    alignmentApplied = false;
    alignPriceAndTax();
  }
  
  // Exécuter immédiatement si le DOM est déjà chargé
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      executeAlignment();
      // Réessayer plusieurs fois pour les pages dynamiques
      setTimeout(executeAlignment, 50);
      setTimeout(executeAlignment, 150);
      setTimeout(executeAlignment, 300);
      setTimeout(executeAlignment, 600);
      setTimeout(executeAlignment, 1000);
      setTimeout(executeAlignment, 2000);
    });
  } else {
    // DOM déjà chargé, exécuter immédiatement
    executeAlignment();
    setTimeout(executeAlignment, 50);
    setTimeout(executeAlignment, 150);
    setTimeout(executeAlignment, 300);
    setTimeout(executeAlignment, 600);
    setTimeout(executeAlignment, 1000);
    setTimeout(executeAlignment, 2000);
  }
  
  // Observer les changements DOM (pour les pages dynamiques comme les variants)
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      let shouldRealign = false;
      
      mutations.forEach(function(mutation) {
        // Vérifier si des éléments ont été ajoutés ou modifiés
        if (mutation.addedNodes.length > 0 || mutation.type === 'attributes') {
          // Vérifier si un des éléments cibles a été modifié
          for (let node of mutation.addedNodes) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && (
                node.classList.contains('product-price--root') ||
                node.classList.contains('product-price--original') ||
                node.classList.contains('product-price--tax') ||
                node.classList.contains('product-price--wrapper') ||
                node.querySelector('.product-price--root') ||
                node.querySelector('.product-price--original') ||
                node.querySelector('.product-price--tax') ||
                node.querySelector('.product-price--wrapper')
              )) {
                shouldRealign = true;
                break;
              }
            }
          }
          if (mutation.target && mutation.target.classList) {
            if (mutation.target.classList.contains('product-price--root') ||
                mutation.target.classList.contains('product-price--original') ||
                mutation.target.classList.contains('product-price--tax') ||
                mutation.target.classList.contains('product-price--wrapper')) {
              shouldRealign = true;
            }
          }
        }
      });
      
      if (shouldRealign) {
        // Délai pour laisser le DOM se stabiliser
        setTimeout(executeAlignment, 50);
        setTimeout(executeAlignment, 200);
        setTimeout(executeAlignment, 500);
      }
    });
    
    // Observer les changements dans le body
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
  }
  
  // Écouter les changements de variants (si le prix change dynamiquement)
  document.addEventListener('change', function(e) {
    // Si un variant est sélectionné, réaligner
    if (e.target && (e.target.tagName === 'SELECT' || e.target.type === 'radio' || e.target.type === 'checkbox')) {
      setTimeout(executeAlignment, 100);
      setTimeout(executeAlignment, 400);
      setTimeout(executeAlignment, 800);
    }
  });
  
  // Écouter aussi les événements input pour les changements de prix dynamiques
  document.addEventListener('input', function(e) {
    if (e.target && e.target.closest && e.target.closest('.product')) {
      setTimeout(executeAlignment, 100);
      setTimeout(executeAlignment, 400);
    }
  });
  
  // Réaligner lors du redimensionnement (au cas où le layout change entre mobile/desktop)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      executeAlignment();
    }, 250);
  });
})();
